const map = {
	"./pages/blog/6_things_to_do.png": 42606,
	"./pages/blog/How_to_design_for_A4_Print.png": 13765,
	"./pages/blog/How_to_print_menus.png": 56623,
	"./pages/blog/How_to_write_for_A4_Print.png": 29912,
	"./pages/blog/Wellness_journal_cover.png": 92389,
	"./pages/blog/bot_to_write.png": 31085,
	"./pages/blog/bulk_printing_a4.png": 49712,
	"./pages/blog/company_printers.png": 84815,
	"./pages/blog/drone_delivery.png": 34521,
	"./pages/blog/history_of_printing.png": 84902,
	"./pages/blog/how_much_does_a_printer_truly_cost.png": 45668,
	"./pages/blog/perfectiong_project_printing.png": 41356,
	"./pages/blog/printing_environmentally_friendly.png": 84573,
	"./pages/blog/printing_in_2025.png": 67411,
	"./pages/blog/printing_in_the_digital_era.png": 54739,
	"./pages/blog/prtint_vs_online.png": 26817,
	"./pages/blog/resignation_letter.png": 50174,
	"./pages/blog/ruslan.png": 81387,
	"./pages/blog/the_art_of_editing.png": 42124,
	"./pages/blog/the_psyhology_of_reading.png": 63273,
	"./pages/bookBinding/BookBinding_1.png": 63586,
	"./pages/bookBinding/BookBinding_2.png": 77593,
	"./pages/bookBinding/BookBinding_3.png": 45488,
	"./pages/bookBinding/BookBinding_bg.png": 48290,
	"./pages/bookBinding/BookBinding_en.png": 89642,
	"./pages/bookPrinting/BookPrinting_1.png": 2232,
	"./pages/bookPrinting/BookPrinting_2.png": 93075,
	"./pages/bookPrinting/BookPrinting_3.png": 25962,
	"./pages/bookPrinting/BookPrinting_4.png": 10629,
	"./pages/bookPrinting/BookPrinting_bg.png": 35492,
	"./pages/bookPrinting/BookPrinting_en.png": 92824,
	"./pages/colorPrinting/ColorPrinting_1.png": 562,
	"./pages/colorPrinting/ColorPrinting_2.png": 48745,
	"./pages/colorPrinting/ColorPrinting_3.png": 24544,
	"./pages/colorPrinting/ColorPrinting_bg.png": 63634,
	"./pages/colorPrinting/ColorPrinting_en.png": 70266,
	"./pages/environment/ecoTruck.png": 16837,
	"./pages/environment/plantation.png": 63719,
	"./pages/environment/recycleLeaves.png": 1402,
	"./pages/environment/reforestation.png": 95570,
	"./pages/environment/sharingHand.png": 42950,
	"./pages/mailboxes/mailboxes_1.png": 80058,
	"./pages/mailboxes/mailboxes_2.png": 4721,
	"./pages/mailboxes/mailboxes_3.png": 64776,
	"./pages/mailboxes/mailboxes_4.png": 39943,
	"./pages/ryman/ryman_1.png": 1218,
	"./pages/ryman/ryman_2.png": 15225,
	"./pages/ryman/ryman_3.png": 99472,
	"./pages/ryman/ryman_4.png": 11695,
	"./pages/students/students_1.png": 41944,
	"./pages/students/students_2.png": 32787,
	"./pages/students/students_3.png": 77578,
	"./pages/students/students_4.png": 62245
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 53823;